/*
========= TO USE ==========
Start local server with:
npm start

Build server version:
npm run build

Then copy files to server. If changing server location, change homepage in package.json
*/
import './App.css';
import '@nlux/themes/nova.css';

import { Fragment } from 'react';
import { AiChat, useAiChatApi, AiChatUI } from '@nlux/react';
import { useAsBatchAdapter, AdapterExtras } from '@nlux/react';

/*
NLUX INTERFACE
========================================
Read:
https://docs.nlkit.com/nlux/reference/ui/ai-chat
*/

// Choose which server to use.

//const apiEndPoint = 'http://localhost:5000/horatio';
//const apiEndPoint = 'https://server.horatio.ai/horatio'; // Heroku
const apiEndPoint = 'https://horatioserver.azurewebsites.net/horatio'; //Azure

const batchText = (message, extras) => {
  return fetch(apiEndPoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "message": message,
      "conversationHistory": extras.conversationHistory
    })
  })
    .then(response => response.json())
    .then(json => json.message);
};

/*

[nlux] API object passed was is not compatible with AiChat.
Only use API objects created by the useAiChatApi() hook.
*/

function App() {

  const adapter = useAsBatchAdapter(batchText, []);
  // Use the AiChat API reference to pass to <AiChat />
  const api = useAiChatApi();

  return (
    <Fragment>
      <div className="App">
        <AiChat
          adapter={adapter}
          api={api}
          composerOptions={{
            placeholder: 'How can I help you today?'
          }}
          conversationOptions={{
            conversationStarters: [
              {label:"Show Holdings",
                prompt: 'What are the top 3 holdings od the L&G UK income fund?'},
              {label:"Compare Sector Alllocations",
                prompt: 'Compare the currency allocation of GB00B3FFXY53 and GB00BP8RYT47 as a single table.'},
              {label:"Compare Investment strategies",
                prompt:'Give me more details of the funds with these ISINs: GB0033049031, GB0007809592 and GB00B7VS8S56. Compare their investment strategies.'
              }
            ]
          }}
        >
          <AiChatUI.Greeting>
            <Fragment>
              <span className="rounded" style={{lineHeight: '1.5'}}><img width="144px" height="144px" src="horatio-logo-square-2.png" /></span>
              <span className="rounded" style={{lineHeight: '1.5'}}><b>Welcome to horatio.ai</b></span>
              <span className="rounded" style={{lineHeight: '1.5'}}>Horatio is an assistant to help in the sales and client servicing for asset management.
                This online sample has access to published data of <b>4000+ UK domiciled</b> funds up to October 2023.</span>
              <span className="rounded" style={{lineHeight: '1.5'}}>Ask horatio about sector and currency allocations, top holdings, fund size, objectives and benchmarks. Horatio can compare, contrast and reformat data.
                Click on the examples below or just ask your question.
              </span>
              <span className="rounded" style={{lineHeight: '1.5', marginBottom: '20px'}}>To find out how to get these capabilities working for your data in your organisation, use the contact details below.</span>
            </Fragment>
          </AiChatUI.Greeting>
        </AiChat>
      </div> 
      <div style={{ textAlign: 'center', lineHeight: '1.5' }}>Uses AI, always check results. Do not use to make decisions</div>
      <div style={{ textAlign: 'center', lineHeight: '1.5' }}>Data provided by <a href="https://fundsaiq.com" target="blank">FundsAIQ</a></div>
      <div style={{ textAlign: 'center', lineHeight: '1.5' }}>To learn how to use horatio.ai on your data at your organisation, contact <a href="mailto:alastair@horatio.ai">alastair@horatio.ai</a></div>
    </Fragment>
  );
}

export default App;

